import { Box, Stack } from '@mui/material';
import { forwardRef } from 'react';
import { ConfirmationCodeDigitInput } from '../RegisterConfirmationPage/register-confirmation-page-components/ConfirmationCodeDigitInput';

type VerificationCodeInputFieldsProps = {
  refs: React.RefObject<HTMLInputElement>[];
};

export const VerificationCodeInputFields = forwardRef<HTMLDivElement, VerificationCodeInputFieldsProps>(
  ({ refs }, ref) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }} ref={ref}>
      <Stack component="fieldset" direction="row" sx={{
        justifyContent: "space-between"
      }}>
        {refs.map((inputRef) => (
          <ConfirmationCodeDigitInput key={crypto.randomUUID()} ref={inputRef} />
        ))}
      </Stack>
    </Box>
  ),
);
